import React, { useState } from 'react'
import moment from 'moment'
import AnDateTimePicker from '../../../../../../components/DateTime/DateTimePicker'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { Alert } from '@mui/material'
import Type from './Type'
import Size from './Size'
import Confirmation from './Confirmation'

const AirwayManagement = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Box padding={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">Airway Management</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
            size="small"
          />
        </Grid>
        <Type moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Size moduleValues={moduleValues} setModuleValues={setModuleValues} />
        <Confirmation
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <Grid item xs={12}>
          <Button
            onClick={() => submitModule('Airway Management', moduleValues)}
            variant="contained"
            color="success"
            fullWidth
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </Box>
  )
}

export default AirwayManagement
